import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fw-bold text-nowrap" }
const _hoisted_2 = { class: "bg-light py-5 px-md-5 h-100 w-100 overflow-auto position-relative" }
const _hoisted_3 = {
  key: 0,
  class: "container"
}
const _hoisted_4 = { class: "mt-4 bg-white px-3 rounded-3" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "Fakturační e-mail", -1)
const _hoisted_8 = { class: "mt-2 bg-white px-3 rounded-3" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "Název", -1)
const _hoisted_12 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "Ulice", -1)
const _hoisted_14 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "Město", -1)
const _hoisted_16 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "PSČ", -1)
const _hoisted_18 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "Země", -1)
const _hoisted_20 = { class: "mt-2 bg-white px-3 rounded-3" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "IČO", -1)
const _hoisted_24 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "DIČ", -1)
const _hoisted_26 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "Plátce DPH", -1)
const _hoisted_28 = { class: "mt-2 bg-white px-3 rounded-3" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "Bankovní účet", -1)
const _hoisted_32 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "IBAN", -1)
const _hoisted_34 = { class: "col-lg-6 col-xl-4 py-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-secondary" }, "Swift/Bic", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_LoadingOverlay = _resolveComponent("LoadingOverlay")!
  const _component_DropdownItem = _resolveComponent("DropdownItem")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_PageTitle = _resolveComponent("PageTitle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.modalRemove)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#modals"
        }, [
          _createVNode(_component_Modal, {
            title: "Odstranit kontakt",
            "btn-accept": "Ano, odstranit",
            alert: _ctx.modalAlert,
            "accept-loading": _ctx.modalLoading,
            onAccept: _ctx.handleRemove,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalRemove = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Opravdu si přejete odstranit kontakt "),
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.contact?.name), 1),
              _createTextVNode("? ")
            ]),
            _: 1
          }, 8, ["alert", "accept-loading", "onAccept"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_SideBar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LoadingOverlay, { loading: _ctx.loading }, null, 8, ["loading"]),
      (_ctx.contact)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_PageTitle, {
              title: _ctx.contact.name
            }, {
              buttons: _withCtx(() => [
                _createVNode(_component_Dropdown, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_DropdownItem, {
                      onClick: _ctx.handleEdit,
                      name: "Upravit"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_DropdownItem, {
                      onClick: _ctx.handleModalRemoveOpen,
                      name: "Trvale odstranit",
                      classes: "text-danger"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.email), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.name), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.street || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.city || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.zip || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.country), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.companyId || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.vatId || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.vatPayer ? 'Ano' : 'Ne'), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.bankAccount || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.iban || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", null, _toDisplayString(_ctx.contact.swiftBic || '-'), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}